export default "__VITE_ASSET__xGuFBKKK__"